import { Component, OnInit, Inject } from '@angular/core';
import { listPagesDB } from 'src/app/shared/tables/list-pages';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-student-innovations-list',
  templateUrl: './student-innovations-list.component.html',
  styleUrls: ['./student-innovations-list.component.scss']
})
export class StudentInnovationsListComponent implements OnInit {

  constructor(private http: HttpClient, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public lists = [];
  message = null;
  class = null;

  ngOnInit() {
    this.http.get<any>(this.api_endpoint+'/studentInnovations/').subscribe(
        data => {
          this.lists = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  delete(id) {
    if(confirm("Are you sure to delete ")){
    this.http.delete<any>(this.api_endpoint+'/studentInnovations/'+ id).subscribe(
      res => {
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Deleted';
          this.class = 'btn btn-success';
          this.ngOnInit();
        }
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
  });
  }
  }

}
